import { curveStepBefore } from 'd3-shape';
import { Curve } from './curve';
export const VH = (options) => {
    return Curve(Object.assign({ curve: curveStepBefore }, options));
};
VH.props = Object.assign({}, Curve.props);
//# sourceMappingURL=vh.js.map